export default __webpack_public_path__ + "static/media/search.6eb11914.svg";